//Form Validation for submission
const Validator = require("validator");
const isEmpty = require("../../../common/functions/is-empty");

export function validateSaveSuppliers(data) {
  const validationErrors = data.map((supplier, index) => {
    let errors = {};

    supplier.name = !isEmpty(supplier.name) ? supplier.name : "";
    supplier.email = !isEmpty(supplier.email) ? supplier.email : "";

    if (Validator.isEmpty(supplier.name)) {
      errors.name = "Supplier Name is required";
    }
    // checks if email is email
    if (!Validator.isEmail(supplier.email)) {
      errors.email = "Email is invalid";
    }
    // checks if a field is empty
    if (Validator.isEmpty(supplier.email)) {
      errors.email = "Supplier Email is required";
    }

    return Object.keys(errors).length !== 0 && errors;
  });

  return {
    validationErrors,
    isValid: validationErrors.every((v) => v === false),
  };
}
